// extracted by mini-css-extract-plugin
export default {"-large":"p1LthHbCFupX1ZX6ML00","container":"YovgSOog2XNXyXegFYDI","arrow":"JnqGo6xwgbpcLqYn6RhK"};